module.exports = __webpack_public_path__ + "595fd47069f7543018d26b830a20b0fd.jpg";